import {ChangeDetectorRef, Component, effect, inject, signal} from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import { IsVolleBerechtigung, IsSpezialUserDirective, IsSupervisorDirective, IsAdminDirective, IsHatWelcomeCallBerechtigungWithoutSpezialUserDirective } from "../../Admin/AdminGuard";
import { PGFilterService } from "../Services/PGFilterService";
import { StatusCountService } from "../Services/StatusCountService";
import {RestClient, Rights, User, StatusRights} from "../../Api/DcoApi/Client/RestClient";
import {AuthorizeDirective} from '../../Directives/AuthorizationDirective';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap/modal';
import {ASBExportDialog} from '../Dialoge/asbexport-dialog/asbexport-dialog';

@Component({
  imports: [
    CommonModule,
    RouterModule,AuthorizeDirective,
    FormsModule, IsVolleBerechtigung, IsSpezialUserDirective, IsSupervisorDirective, IsAdminDirective, IsHatWelcomeCallBerechtigungWithoutSpezialUserDirective
  ],
  selector: 'MainTemplate',
  templateUrl: './MainTemplate.html',
  standalone: true,
  styleUrl: './MainTemplate.css'
})
export class MainTemplate {
  currentDate = new Date();
  ShowExport = signal<boolean>(false);

  toggleCollaps() {
    this.ShowExport.set(!this.ShowExport());
  }

  constructor(public statusService: StatusCountService, public pgService: PGFilterService, private cdr: ChangeDetectorRef) {

  }
  private modalService = inject(NgbModal);
  openExportPopup(abmelden:boolean){
    var modal = this.modalService.open(ASBExportDialog,{size:'lg'});
    modal.componentInstance.Abmelden = abmelden;
  }


  Import() {
    const fileInput = document.createElement('input');
    fileInput.type = 'file';
    fileInput.accept = '.xlsx, .xls'; // Nur Excel-Dateien zulassen

    // 2. Event-Handler für die Dateiauswahl registrieren
    fileInput.onchange = (event: Event) => {
      const input = event.target as HTMLInputElement;

      if (input.files && input.files.length > 0) {
        const file = input.files[0];

        this.Client.PostFile("/GenehmigungsImport", file);
      }
    };

    // 5. Den nativen Dateiauswahldialog des Browsers öffnen
    fileInput.click();
  }

  Client: RestClient = new RestClient();
  protected readonly Rights = Rights;
  protected readonly StatusRights = StatusRights;
  protected readonly User = User;
}
